<template>
  <svg class="shrink-0" :height="size" :width="size" viewBox="0 0 100 100">
    <circle
      cx="50"
      cy="50"
      r="45"
      fill="none"
      stroke="currentColor"
      :stroke-width="strokeWidth"
      class="text-border"
    />
    <circle
      cx="50"
      cy="50"
      r="45"
      fill="none"
      stroke="currentColor"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      class="text-blue-500 transition-all duration-300"
      :stroke-dasharray="circumference"
      :stroke-dashoffset="circumference - value * circumference"
      transform="rotate(-90 50 50)"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    value: number;
    size?: number;
    strokeWidth?: number;
  }>(),
  {
    size: 12,
    strokeWidth: 14,
  }
);

const circumference = 2 * Math.PI * 45;
</script>
